import React, { useState, useEffect,useMemo } from 'react';
import { useStorefrontSettings } from '../../hooks/StorefrontSettingsContext';
import Storefront from '../../services/Storefront';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Loading from '../Loading';
import TextField from '@mui/material/TextField';
import { GridToolbarContainer, GridToolbarFilterButton, GridToolbarExport, GridToolbarDensitySelector } from '@mui/x-data-grid-premium';
import Paper from '@mui/material/Paper';
import Notifications from '../../services/Notifications';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { FormLabel } from '@mui/material';
import { useStorefrontAdministrationConfig } from '../../hooks/StorefrontAdministrationConfigContext';
import TranslatableDataGrid from '../shared/TranslatableDataGrid';
import { ThemeProvider } from '@mui/material/styles';
import StorefrontAdminTheme from '../shared/MUIStyles/StorefrontAdminTheme';
import Typography from '@mui/material/Typography';
import MUIModal from '../shared/MUIModal';
import MUIAlertModal from '../shared/MUIAlertModal';

export const NewsAdministration = () => {
    const storeData = useStorefrontSettings();
    const localized = useStorefrontAdministrationConfig().labels;
    const [fetching, setFetching] = useState(false);
    const [dateValue, setDateValue] = useState(new Date());
    const [rows, setRows] = useState([]);
    
    const [openUpdate, setOpenUpdate] = React.useState(false);
    const [openDelete, setOpenDelete] = React.useState(false);
    const [openAdd, setOpenAdd] = React.useState(false);
    const [selectedRow, setSelectedRow] = React.useState(null);
    const theme = StorefrontAdminTheme;
    const responseMessages = {
        "DuplicateKeyViolation": localized.NewsDuplicateKeyViolation,
        "GenericFailure": localized.NewsGenericError,
        "DeleteSuccess": localized.NewsDeleteSuccess,
        "UpdateSuccess": localized.NewsUpdateSuccess,
        "AddSuccess": localized.NewsAddSuccess
    };
    var addDateValue = new Date();
    useEffect(() => {
        getNews();
    }, []);

    const customToolbar = () => {
        return (
            <GridToolbarContainer>

                <Box sx={{ flexGrow: 1 }} />
                <GridToolbarFilterButton
                    slotProps={{
                        tooltip: { title: 'Filter list' }
                    }}
                    variant="outlined"
                    color="update"
                />
                <GridToolbarDensitySelector
                    slotProps={{
                        tooltip: { title: 'Change density' }
                    }}
                    variant="outlined"
                    color="update"
                />

                <GridToolbarExport
                    printOptions={{ disableToolbarButton: true }}
                    slotProps={{
                        tooltip: { title: 'Export data' }
                    }}
                    variant="outlined"
                    color="update"
                />
                <strong>
                    <Button
                        variant="standard"
                        color="success"
                        style={{ marginLeft: 16 }}
                        onClick={(e) => handleClickOpenAdd(e)}
                    >
                        {localized.StorefrontAdminAdd}
                    </Button>
                </strong>

            </GridToolbarContainer>
        );
    }

    const getNews = () => {
        setFetching(true);
        Storefront.getNews(storeData.storefrontNumber).then(loaded);        
    }

    const updateNews = async (form, type) => {
        var useDate = type==="add" ? addDateValue : dateValue;
        var request = {
            id: form.id ?? null,
            title: form.title ?? null,
            content: form.content ?? null,
            postDate: useDate ?? null,
            priority: Number(form.priority) ?? null,
            storefrontNumber: storeData.storefrontNumber,
            operationType: type
        };
        addDateValue = new Date();
        return await Storefront.updateNews(request).then((res) => {
            if (res) {
                const notificationType = res.response.endsWith("Success") ? "message" : "error";
                const message = responseMessages[res.response];

                if (message) {
                    Notifications[notificationType](message);
                }
                else {
                    Notifications.error(localized.NewsErrorNotification);
                }
                getNews();
            }
        });
    }

    const loaded = (data) => {
        if (data) {
            mapRows(data);
        }
        setFetching(false);
    }

    const mapRows = (data) => {
        var rows = [];
        data.news.forEach((newsEntry) => {

            rows.push({
                id: newsEntry.id,
                title: newsEntry.title,
                content: newsEntry.content,
                postDate: newsEntry.postDate,
                priority: newsEntry.postPriority,
                lastModifiedBy: newsEntry.lastModifiedBy,
                lastModifiedByDate: newsEntry.lastModifiedByDate,
                firstName: newsEntry.modifyUserFirstName,
                lastName: newsEntry.modifyUserLastName,
            });
        });
        setRows(rows);
    }

    const handleClickOpenUpdate = (e, row) => {
        e.stopPropagation();
        setDateValue(row.postDate);
        setSelectedRow(row);
        setOpenUpdate(true);
    };

    const handleDateChangeUpdate = (e) => {
        setDateValue(e);
    }

    const handleCloseUpdate = () => {
        setOpenUpdate(false);
        setDateValue(new Date());
    };

    const handleClickOpenDelete = (e, row) => {
        e.stopPropagation();
        setSelectedRow(row);
        setOpenDelete(true);
    };

    const handleCloseDelete = () => {
        setOpenDelete(false);
    };

    const handleClickOpenAdd = (e) => {
        e.stopPropagation();
        setOpenAdd(true);
    };

    const handleDateChangeAdd = (e) => {
        addDateValue=e;
    };

    const handleCloseAdd = () => {
        setOpenAdd(false);
        addDateValue = new Date();
    };

    
const renderDeleteButton = (row) => (
        <MUIAlertModal
            open={openDelete}
            onClose={handleCloseDelete}
        title={localized.NewsAreYouSureDelete}
            message={
                <>
                    <h3>{localized.NewsAreYouSureDelete}</h3>
                    <strong>{row.code}</strong>
                </>
            }
            confirmLabel={localized.StorefrontAdminDelete}
            cancelLabel={localized.StorefrontAdminCancel}
            onConfirm={(event) => {
                event.preventDefault();
                const formData = new FormData(event.currentTarget);
                formData.append("id", row.id);
                formData.append("priority", row.priority);
                const formJson = Object.fromEntries(formData.entries());
                updateNews(formJson, "delete");
                handleCloseDelete();
            }}
            confirmButtonProps={{ color: "error" }}
            cancelButtonProps={{ color: "update" }}
        />
    );
const renderUpdateButton = (row) => (
        <MUIModal
            open={openUpdate}
            onClose={handleCloseUpdate}
            title={localized.UpdateNewsEntries}
            onSubmit={(event) => {
                event.preventDefault();
                const formData = new FormData(event.currentTarget);
                formData.append("id", row.id);
                const formJson = Object.fromEntries(formData.entries());
                updateNews(formJson, "update");
                handleCloseUpdate();
            }}
            submitLabel={localized.StorefrontAdminUpdate}
            cancelLabel={localized.StorefrontAdminCancel}
            showDefaultButtons={true}
            submitButtonProps={{ color: "update" }}
            cancelButtonProps={{ color: "error" }}
            maxWidth="sm"
            fullWidth
        >
            <h3>{localized.ValuesEligibleForUpdateBelow}</h3>

            <TextField
                defaultValue={row.title}
                inputProps={{ maxLength: 250 }}
                required
                margin="dense"
                id="title"
                name="title"
                label={localized.Title}
                type="text"
                fullWidth
                variant="standard"
            />

            <TextField
                defaultValue={row.content}
                required
                margin="dense"
                id="content"
                name="content"
                label={localized.Content}
                type="text"
                fullWidth
                variant="standard"
            />

            <TextField
                defaultValue={row.priority}
                inputProps={{ maxLength: 3 }}
                required
                margin="dense"
                id="priority"
                name="priority"
                label={localized.Priority}
                type="number"
                fullWidth
                variant="standard"
            />

            <FormLabel required sx={{ fontSize: 10 }}>
                {localized.PostDate + ": "}
            </FormLabel>

            <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DatePicker
                value={dateValue ? new Date(dateValue) : null}
                onChange={(newValue) => setDateValue(newValue)}
                onAccept={(x) => handleDateChangeUpdate(x, row)}
                slotProps={{
                    textField: {
                        required: true,
                        fullWidth: true,
                        inputProps: { style: { fontSize: 14 } },
                    },
                    popper: {
                        modifiers: [
                            {
                                name: 'zIndex',
                                enabled: true,
                                phase: 'write',
                                fn: ({ state }) => {
                                    state.styles.popper.zIndex = 1601;
                                },
                            },
                        ],
                    },
                }}
                disablePortal               
              
            />

            </LocalizationProvider>
        </MUIModal>
    );
const renderAddButton = () => (
        <>
            <strong>
                <Button
                    variant="standard"
                    color="success"
                    style={{ marginLeft: 16 }}
                    onClick={handleClickOpenAdd}
                >
                    {localized.StorefrontAdminAdd}
                </Button>
            </strong>

            <MUIModal
                open={openAdd}
                onClose={handleCloseAdd}
                title={localized.AddNews}
                onSubmit={(event) => {
                    event.preventDefault();
                    const formData = new FormData(event.currentTarget);
                    const formJson = Object.fromEntries(formData.entries());
                    updateNews(formJson, "add");
                    handleCloseAdd();
                }}
                submitLabel={localized.StorefrontAdminAdd}
                cancelLabel={localized.StorefrontAdminCancel}
                showDefaultButtons={true}
                submitButtonProps={{ color: "success" }}
                cancelButtonProps={{ color: "error" }}
                maxWidth="sm"
                fullWidth
            >
                <h3>{localized.FillRequiredFieldsBelow}</h3>

                <TextField
                    inputProps={{ maxLength: 250 }}
                    required
                    margin="dense"
                    id="title"
                    name="title"
                    label={localized.Title}
                    type="text"
                    fullWidth
                    variant="standard"
                />

                <TextField
                    required
                    margin="dense"
                    id="content"
                    name="content"
                    label={localized.Content}
                    type="text"
                    fullWidth
                    variant="standard"
                />

                <TextField
                    inputProps={{ maxLength: 3 }}
                    required
                    margin="dense"
                    id="priority"
                    name="priority"
                    label={localized.Priority}
                    type="number"
                    fullWidth
                    variant="standard"
                />

                <FormLabel required sx={{ fontSize: 10 }}>
                    {localized.PostDate + ": "}
                </FormLabel>

                <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DatePicker
                        value={addDateValue}
                        onChange={(newValue) => setAddDateValue(newValue)}
                        onAccept={(x) => handleDateChangeAdd(x)}
                        slotProps={{
                            textField: {
                                required: true,
                                fullWidth: true,
                                inputProps: { style: { fontSize: 14 } },
                            },
                            popper: {
                                modifiers: [
                                    {
                                        name: 'zIndex',
                                        enabled: true,
                                        phase: 'write',
                                        fn: ({ state }) => {
                                            state.styles.popper.zIndex = 1600;
                                        },
                                    },
                                ],
                            },
                        }}
                        disablePortal
                    />
                </LocalizationProvider>
            </MUIModal>
        </>
    );
  
    const columns = [
        {
            field: 'title',
            headerName: localized.Title,
            headerAlign: 'left',
            flex: 1
        },
        {
            field: 'content',
            headerName: localized.Content,
            headerAlign: 'left',
            flex: 1
        },
        {
            field: 'priority',
            headerName: localized.Priority,
            headerAlign: 'center',
            align: 'center',
            flex: 1
        },
        {
            field: 'lastModifiedBy',
            headerName: localized.LastModifiedBy,
            headerAlign: 'left',
            flex:1
        },
        {
            field: 'postDate',
            headerName: localized.PostDate,
            headerAlign: 'left',
            flex: 1
        },
        {
            field: 'lastModifiedByDate',
            headerName: localized.LastModificationDate,
            headerAlign: 'left',
            flex: 1
        },
        {
            field: 'updateButton',
            headerName: localized.StorefrontAdminUpdate,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params) => {
                return (
                    <strong>
                        <Button
                            variant="standard"
                            color="update"
                            style={{ marginLeft: 16 }}
                            onClick={(e) => handleClickOpenUpdate(e, params.row)}
                        >
                            {localized.StorefrontAdminUpdate}
                        </Button>
                    </strong>
                )
            },
            disableClickEventBubbling: true

        },
        {
            field: 'deleteButton',
            headerName: localized.StorefrontAdminDelete,
            headerAlign: 'center',
            renderCell: (params) => {
                return (
                    <strong>
                        <Button
                            variant="standard"
                            color="error"
                            style={{ marginLeft: 16 }}
                            onClick={(e) => handleClickOpenDelete(e, params.row)}
                        >
                            {localized.StorefrontAdminDelete}
                        </Button>
                    </strong>
                )
            },
            disableClickEventBubbling: true
        }
    ];
    const newsItems = useMemo(() => {
        return (
            <Paper sx={{ height: 700, width: '100%' }}>
                <TranslatableDataGrid rows={rows} columns={columns} insetToolbar={customToolbar} labels={localized} />
            </Paper>
        );
    }, [rows, localized]);

    return (
        <>
            {
                fetching && <Loading type="brand" />
            }
            {
                !fetching && (localized && Object.keys(localized).length >0) && 
                <>
                    <ThemeProvider theme={theme}>
                        <Typography variant="h1">{localized.NewsAdministrationHeader}</Typography>
                        {newsItems}                        
                        {openUpdate && renderUpdateButton(selectedRow)}
                        {openDelete && renderDeleteButton(selectedRow)}
                        {openAdd && renderAddButton()}
                    </ThemeProvider>
                </>
            }
        </>
    );
}

export default NewsAdministration;

